module.exports = __webpack_public_path__ + "media/images/kds/loading_spinner-f12bb95e405f7d233aced4a476025723.gif";